import { render, staticRenderFns } from "./PriceConfigCreate.vue?vue&type=template&id=103028be&"
import script from "./PriceConfigCreate.vue?vue&type=script&lang=ts&"
export * from "./PriceConfigCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports